<template>
    <div class="PageDashboard">
    	<transition name="PageGroupTranstion" enter-active-class="animated PageGroupFadeIn">
    		<div>
		    	<div class="row margin-bottom-xlarge">
		    		<div class="col-xs-12">
		    			<h1 class="st-headline st-headline--1">{{ $t('Dashboard') }}</h1>
		    		</div>
		    	</div>

				<div class="row margin-bottom-xlarge">
					<div class="col-xs-12 col-sm-6" v-if="channel.pages.presentations">
						<h2 class="st-headline st-headline--2">{{ $t('Latest presentation') }}</h2>
						<table class="st-table st-table--full">
				            <thead>
				                <tr>
				                	<th>{{ $t('Name') }}</th>
				                	<th>{{ $t('Created by') }}</th>
				                </tr>
				            </thead>
				            <tbody>
				            	<tr v-if="!latestpresentation">
				            		<td colspan="3">
				            			<div class="text-center"><div class="inline-block spinner"></div></div>
				            		</td>
				            	</tr>
				            	<tr v-else v-for="entry in latestpresentation" :class="{
				            		'has-action': (entry.urls && Object.keys(entry.urls).length > 0)
				            	}">
				            		<td>
				            			<c-presentation :data="entry" :simple="true"></c-presentation>
				            		</td>
				            		<td>
				            			<c-user v-if="entry.createdUser" :data="entry.createdUser"></c-user>
				            		</td>
				            	</tr>
				            </tbody>
				        </table>
					</div>
				</div>
				<div class="row margin-bottom-xlarge">
					<div class="col-xs-12 col-sm-6" v-if="channel.pages.presentations">
						<h2 class="st-headline st-headline--2">{{ $t('Next appointment') }}</h2>
						<table class="st-table st-table--full">
				            <thead>
				                <tr>
				                	<th>{{ $t('Name') }}</th>
				                	<th>{{ $t('Appointment') }}</th>
				                </tr>
				            </thead>
				            <tbody>
				            	<tr v-if="!nextappointment">
				            		<td colspan="3">
				            			<div class="text-center"><div class="inline-block spinner"></div></div>
				            		</td>
				            	</tr>
				            	<tr v-else v-for="entry in nextappointment" :class="{
				            		'has-action': (entry.urls && Object.keys(entry.urls).length > 0)
				            	}">
				            		<td><c-presentation :data="entry" :simple="true"></c-presentation></td>
				            		<td>{{ entry.appointment }}</td>
				            	</tr>
				            </tbody>
				        </table>
					</div>
				</div>
			</div>
		</transition>
    </div>
</template>

<script>
import UserList from '@/components/UserList';
import CPresentation from '@/components/c-presentation';
import CUser from '@/components/c-user';
import MultiSelect from '@/components/MultiSelect';
import DynamicColumn from '@/components/DynamicColumn';
import help_user from '@/helpers/user';
import help_rest from '@/helpers/rest';

export default {
	name: 'PageDashboard',
	components: {
		DynamicColumn,
		MultiSelect,
		CPresentation,
		CUser,
		UserList
	},
	data(){
		return {
			latestpresentation: false,
			nextappointment: false,
		}
	},
	computed: {
		channel(){
			return this.$store.getters.channel;
		}
	},
	mounted(){
		this.update();
	},
	methods: {
		...help_rest,

		update(){
			let self = this;

			this.restget(this.channel.urls.presentations + '?sort=-created', 'latestpresentation')
				.then(function (message) {
					console.log('latestpresentation', message);
					self.latestpresentation = message || [];
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					console.error(error);
				});

			this.restget(this.channel.urls.presentations + '?sort=-appointment', 'nextappointment')
				.then(function (message) {
					console.log('nextappointment', message);
					self.nextappointment = message || [];
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					console.error(error);
				});
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageDashboard.vue